import styles from "./styles.module.scss"
import cn from "clsx"
import { render } from "storyblok-rich-text-react-renderer"
import type { FC, HTMLAttributes } from "react"


interface DescriptionProps
extends HTMLAttributes<HTMLDivElement> {
  content: any,
  shrink?: boolean,
}

export const Description: FC<DescriptionProps> = ({ 
  className, children, content, shrink, ...rest 
}) => (
  <div {...rest} className={cn(styles.description, className, {[styles.shrink]: shrink})}>
    {render(content)}
    {children}
  </div>
)
